import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const betsOf3dNumber=(threeDNumberId,token)=>async dispatch=>{
    dispatch({
        type:actionTypes.BETS_OF_3D_NUMBER_START
    })
    const options={
        url:`${api}/bets/betThreeDNumbers/${threeDNumberId}`,
        method:'GET',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{}
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.BETS_OF_3D_NUMBER_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.BETS_OF_3D_NUMBER_FAIL,
                payload:getMessage(error)
            }))
}